import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { Loader2 } from 'lucide-react';
import { Button } from '../common/Button';
import { useCreditStore } from '../../stores/creditStore';
import { WithCreditsModal } from './WithCreditsModal';
import type { ModalParams } from '../../utils/modalUrlParams';

interface WalletSummaryProps {
  outerClassName?: string;
  modalParams?: ModalParams | null;
}

const WalletSummary: React.FC<WalletSummaryProps> = ({ outerClassName, modalParams }) => {
  const { t } = useTranslation('common');
  const { balance, loadingBalance, refreshBalance } = useCreditStore();

  useEffect(() => {
    refreshBalance();
  }, [refreshBalance]);

  return (
    <div className={twMerge('flex flex-col gap-0.5 relative', outerClassName)}>
      <div className="px-2 pb-2 text-sm font-bold text-secondary">{t('wallet.title')}</div>

      <div className="border border-gray-800 rounded-3xl py-8 px-5 shadow-sm flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between md:py-2 md:px-2 md:rounded-full">
        <div className="flex flex-col pl-4 sm:flex-row sm:items-center sm:gap-6">
          <div className="flex items-center gap-2">
            <span className="text-xs text-secondary">{t('wallet.credits')} :</span>
            {loadingBalance ? (
              <Loader2 className="h-6 w-6 animate-spin text-secondary" />
            ) : (
              <span className="text-4xl font-bold text-secondary">{balance}</span>
            )}
          </div>
        </div>

        <div className="self-start sm:self-auto w-full sm:w-auto">
          <WithCreditsModal modalParams={modalParams}>
            {openCreditsModal => (
              <Button variant="primary" onClick={openCreditsModal}>
                {t('wallet.manage')}
              </Button>
            )}
          </WithCreditsModal>
        </div>
      </div>
    </div>
  );
};

export default WalletSummary;
